import { addLoadingState } from '../shared/loading-state-helpers';

export default class SubmitHandler {
  submitButtonClass = 'js-button-submit';

  subscribeSubmitEvent = (form) => {
    form.addEventListener('submit', () => {
      const submitButton = form.querySelector(`.${this.submitButtonClass}[type="submit"]`);
      if (submitButton) {
        addLoadingState(submitButton);
      }
    });
  };

  initializeEventListeners = () => {
    document.querySelectorAll('form').forEach(this.subscribeSubmitEvent);
  };
}
